export default __webpack_public_path__ + "static/media/keerthi.c81f8766.png";